module.exports = __webpack_public_path__ + "img/banner02.6b979242.jpg";